module.exports = __webpack_public_path__ + "img/744.4b691f65.jpg";